import Cookies from "js-cookie";

const handler = ($) => {

	/**
	 * Display login modal when not logged user clicks on Bookmark Toggle
	 */
	const $modal = $('#modal-login-popup');

	$('.resources-hub-block .bookmark-toggle').on( 'click', function( e ) {

		if( $('body').hasClass('user-not-loged') ) {
			e.preventDefault();
			$('body').trigger('before-modal-open');
	
			$modal.find('input[name=post_id]').val( $(this).data('id'));
			$modal.find('input[name=post_type]').val( $(this).data('post-type'));
	
			$modal.fadeIn('fast', function() {
				$('body').addClass('is-modal-open').trigger('is-modal-open');
				$modal.find('input[type=email]').focus();
			});
		}

	});

	/**
	 * Handle login form
	 */
	$('#modal-login-popup form').on( 'submit', function( e ) {
		e.preventDefault();

		const $form = $(this),
		$email = $form.find('input[name=email]'),
		email = $.trim( $email.val() ),
		$password = $form.find('input[name=password]'),
		password = $password.val(),
		$submit = $form.find('button[type=submit]'),
		$errors = $form.find('.errors'),
		bookmarkPostID = $form.find('input[name=post_id]').val(),
		bookmarkPostType = $form.find('input[name=post_type]').val();

		if( email == '' ) {
			$email.focus();
			return false;
		}

		if( password == '' ) {
			$password.focus();
			return false;
		}

		$.ajax({
			url: themeVars.ajaxurl,
			type: 'POST',
			dataType: 'json',
			data: {
				action: 'user_login',
				action_after_login: 'toggle_bookmark',
				nonce: Cookies.get('wordpress_pen_ajax_nonce'),
				data: $form.serialize()
			},
			beforeSend: function() {

				$submit.attr('disabled', 'disabled');
				$errors.html('');

			},
			success: function( answer ) {

				$submit.removeAttr('disabled');

				if( answer.success == false ) {

					$errors.html( answer.data.message );

				} else if( answer.success == true ) {

					$('body').removeClass('user-not-loged');
					$modal.fadeOut('fast', function() {

						if( answer.data.action_result == true ) {
							$('.bookmark-toggle[data-id=' + bookmarkPostID + ']').removeClass('inactive');
						} 

						window.location.reload();

					});

				}

			}
		});

	});

};

export default (($) => $(handler))(jQuery);
